import runtime from '../runtime';
import OrganizationRoutes from './OrganizationRoutes';
import SuperAdminRoutes from './SuperAdminRoutes';

const AppRoutes = () => {
    if (runtime.isSuperAdmin) {
        return <SuperAdminRoutes />;
    }

    return <OrganizationRoutes />;
};

export default AppRoutes;
